import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from "vuex-persist";

// modules
import user from "./modules/user";
import users from "./modules/users";
import menu from "./modules/menu";
import requestTypes from "./modules/requests/request-types";
import licenses from "./modules/licenses";
import services from "./modules/services";
import information from "./modules/information";
import loanOfficers from "./modules/loan-officers";
import optOut from "./modules/requests/opt-out";
import deleteReq from "./modules/requests/delete";
import knowReq from "./modules/requests/know";

Vue.use(Vuex);

const vuexLocalStorage = new VuexPersist({
   key: 'vuex',
   storage: window.localStorage,
   reducer: state => ({
      user:
      {
         email: state.user.email,
         isAdmin: state.user.isAdmin,
         photoURL: state.user.photoURL,
         token: state.user.token,
         username: state.user.username
      }
   })
})

export default new Vuex.Store({
   modules: {
      user,
      users,
      menu,
      requestTypes,
      licenses,
      services,
      information,
      loanOfficers,
      optOut,
      deleteReq,
      knowReq
   },
   plugins: [
      vuexLocalStorage.plugin
   ]
});